import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'environments/environment';

const MOCK_PAYOUT_WALLET = { currencyCode: 'XOF', walletType: 'PAYOUT', balance: 1250000, active: true };
const MOCK_COLLECTION_WALLET = { currencyCode: 'USD', walletType: 'COLLECTION', balance: 900000, active: true };

const MOCK_FUNDING_REQUEST = {
  id: 1,
  clientPublicId: 'mock-client',
  clientName: 'Client Démo',
  currencyIsoCode: 'XOF',
  amount: 500000,
  paymentReference: 'VIR-MOCK-0001',
  paymentDate: '2026-08-22',
  comment: null,
  proofFileOriginalName: null,
  status: 'PENDING',
  rejectionReason: null,
  reviewedBy: null,
  reviewedAt: null,
  createdAt: '2026-08-22T09:15:00',
  updatedAt: '2026-08-22T09:15:00'
};

const EMPTY_PAGE = { content: [], totalElements: 0, totalPages: 0, number: 0, size: 20 };

@Injectable()
export class FundingRequestMockInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!environment.mockFundingRequests) {
      return next.handle(request);
    }

    if (request.method === 'GET' && /\/wallets(\?|$)/.test(request.url)) {
      const wallets = request.url.includes('walletType.equals=PAYOUT')
        ? [MOCK_PAYOUT_WALLET]
        : request.url.includes('walletType.equals=COLLECTION')
          ? [MOCK_COLLECTION_WALLET]
          : [MOCK_PAYOUT_WALLET, MOCK_COLLECTION_WALLET];
      return of(new HttpResponse({
        status: 200,
        body: { content: wallets, totalElements: wallets.length, totalPages: 1, number: 0, size: 20 }
      }));
    }

    if (request.method === 'POST' && request.url.endsWith('/portal/funding-requests')) {
      return of(new HttpResponse({ status: 201, body: MOCK_FUNDING_REQUEST }));
    }

    if (request.method === 'GET' && request.url.endsWith('/funding-requests')) {
      return of(new HttpResponse({ status: 200, body: EMPTY_PAGE }));
    }

    if (request.method === 'GET' && /\/funding-requests\/\d+\/proof$/.test(request.url)) {
      return of(new HttpResponse({ status: 200, body: new Blob(['mock-proof-content'], { type: 'application/pdf' }) }));
    }

    return next.handle(request);
  }
}
